// extracted by mini-css-extract-plugin
export var originalPrice = "_tr-0";